import React, { FunctionComponent } from 'react';
import { parsePublishedAt } from '../../../services/helpers/GeneralHelper';
import { hasOrigin } from '../../../constants/GlobalHelpers';
import { ImageModel } from '../../../services/content/image/models/ImageModel';

type Props = {
    publishedAt: string;
    image: ImageModel | null;
    className?: string;
};

export const PhotoBy: FunctionComponent<Props> = ({ publishedAt, image, className }) => {
    return (
        <div className={`${className}`}>
            <div className='text-start d-md-block'>
                {image && hasOrigin(image) ? `Фотокредит ${image.origin?.name}` : ''}
            </div>
            <div>
                <div className='d-none d-md-block'>{parsePublishedAt(publishedAt)}</div>
            </div>
        </div>
    );
};
